import { createRenderBatcher } from "./batcher.mjs";
const { schedule: microtask, cancel: cancelMicrotask } = /* @__PURE__ */ createRenderBatcher(queueMicrotask, true);
export {
  cancelMicrotask,
  microtask
};
